import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import SwitchInput from "commons/ui/input/SwitchInput";
import WysiwygSimpleEditor from "commons/ui/input/WysiwygSimpleEditor";
import Paper from "commons/ui/Paper";

import AttachmentPicker from "components/ui/AttachmentPicker";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";

import { DocumentFormHook } from "hooks/form/useDocumentForm";

type PropsType = {
    formDocumentHook: DocumentFormHook;
};

function DocumentForm({ formDocumentHook }: Readonly<PropsType>) {
    const { setSingleFile, formHook } = formDocumentHook;

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Impostazioni</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <SwitchInput
                                checked={form.enabled}
                                label={"Visibile"}
                                setValue={setValue}
                                path={"enabled"}
                                alignedToForm
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo Italiano</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                startAdornment={TwoLanguagesAdornment("it")}
                                value={form.text.it.title}
                                setValue={setValue}
                                path={"text.it.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione"}
                                bigDefault={true}
                                value={form.text.it.description}
                                path={"text.it.description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    {/* Testo Inglese — hidden
                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo Inglese</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                label={"Titolo"}
                                startAdornment={TwoLanguagesAdornment("en")}
                                value={form.text.en.title}
                                setValue={setValue}
                                path={"text.en.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <WysiwygSimpleEditor
                                label={"Descrizione"}

                                value={form.text.en.description}
                                path={"text.en.description"}
                                setValue={setValue}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>
                    */}

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Allegato</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <AttachmentPicker
                                buttonLabel={"Carica PDF"}
                                accept={"application/pdf"}
                                file={form.attachment}
                                setFile={(file) => setSingleFile(file, "attachment")}
                                errors={checkErrorVisibility("attachment")}
                            />
                        </GridItem>
                    </GridRow>
                </GridColumn>
            </Paper>
        </GridColumn>
    );
}

export default DocumentForm;
